var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"titleText"},[_vm._v("业务数据报表")])}
var staticRenderFns = []

export { render, staticRenderFns }